import React from 'react'
import { FAIL, LOADING, SUCCESS } from '../../../redux_store/actionTypes';
import Button from '../../templates/Button';
import LoadingModal from '../../templates/modals/LoadingModal';
import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { EditPencil, Cancel, CheckCircledOutline, Plus, CreditCard } from 'iconoir-react';
import { addPaymentMethod, getAllPaymentMenthods, updatePaymentMethodById } from '../../../redux_store/payment_methods/payment_methods_thunk';
import toast from '../../templates/ToastMessage'
import AddPaymentMethodModal from '../../templates/modals/AddPaymentMethodModal';

const PaymentMethodsPage = () => {
  const dispatch = useDispatch();
  const [methodDetails, setMethodDetails] = useState({});
  const [showCreateModal, setShowCreateModal] = useState(false);
  const { payment_methods, status, message } = useSelector((state) => state.payment_method);

  useEffect(() => {
    if (status === FAIL) {
      toast({ message, status });
    } else if (status === SUCCESS) {
      dispatch(getAllPaymentMenthods());
      toast({ message, status });
      setShowCreateModal(false);
    }
    // eslint-disable-next-line
  }, [status]);

  useEffect(() => {
    dispatch(getAllPaymentMenthods());
    // eslint-disable-next-line
  }, []);

  return (
    <div className='space-y-6'>
      {status === LOADING && <LoadingModal message={'Loading data...'} />}
      {showCreateModal && <AddPaymentMethodModal
        details={methodDetails}
        onInputChange={(e) => {
          const { name, value } = e.target;
          setMethodDetails({ ...methodDetails, [name]: value })
        }}
        onSubmit={() => dispatch(addPaymentMethod(methodDetails))}
        onCancel={() => setShowCreateModal(false)}
      />}

      {/* Page Header */}
      <div className='flex items-center justify-between'>
        <div>
          <h1 className='text-2xl font-bold text-surface-800'>Payment Methods</h1>
          <p className='text-surface-500 mt-1'>Manage available payment options</p>
        </div>
        <Button
          onClick={() => setShowCreateModal(true)}
          label={'Add Payment Method'}
          variant="primary"
          icon={<Plus strokeWidth={2} className='w-4 h-4' />}
        />
      </div>

      {/* Payment Methods Table */}
      <div className='card p-0 overflow-hidden'>
        <table className="table-modern">
          <thead>
            <tr>
              <th>Payment Method</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {payment_methods && payment_methods.length > 0 ? payment_methods.map((method, index) =>
              <tr key={method.id || index}>
                <td>
                  <div className='flex items-center gap-3'>
                    <div className='w-10 h-10 rounded-xl bg-indigo-100 flex items-center justify-center'>
                      <CreditCard strokeWidth={2} className='w-5 h-5 text-indigo-600' />
                    </div>
                    <span className='font-semibold text-surface-800'>{method.method}</span>
                  </div>
                </td>
                <td>
                  {method.active ? (
                    <span className='badge-success'>
                      <span className='w-1.5 h-1.5 rounded-full bg-emerald-500' />
                      Active
                    </span>
                  ) : (
                    <span className='badge-danger'>
                      <span className='w-1.5 h-1.5 rounded-full bg-rose-500' />
                      Inactive
                    </span>
                  )}
                </td>
                <td>
                  <div className='flex items-center gap-2'>
                    <button
                      onClick={() => { }}
                      className='btn-ghost p-2 rounded-lg'
                      title='Edit'
                    >
                      <EditPencil strokeWidth={2} className='w-4 h-4' />
                    </button>
                    {method.active ? (
                      <button
                        onClick={() => {
                          dispatch(updatePaymentMethodById({
                            id: method.id, details: { active: false }
                          }));
                        }}
                        className='btn-ghost p-2 rounded-lg text-rose-500 hover:text-rose-600 hover:bg-rose-50'
                        title='Deactivate'
                      >
                        <Cancel strokeWidth={2} className='w-4 h-4' />
                      </button>
                    ) : (
                      <button
                        onClick={() => {
                          dispatch(updatePaymentMethodById({
                            id: method.id, details: { active: true }
                          }));
                        }}
                        className='btn-ghost p-2 rounded-lg text-emerald-500 hover:text-emerald-600 hover:bg-emerald-50'
                        title='Activate'
                      >
                        <CheckCircledOutline strokeWidth={2} className='w-4 h-4' />
                      </button>
                    )}
                  </div>
                </td>
              </tr>
            ) :
              <tr>
                <td colSpan={3} className="text-center py-12">
                  <div className='flex flex-col items-center gap-3'>
                    <div className='w-16 h-16 rounded-2xl bg-surface-100 flex items-center justify-center'>
                      <CreditCard strokeWidth={1.5} className='w-8 h-8 text-surface-400' />
                    </div>
                    <div>
                      <p className='font-medium text-surface-600'>No payment methods</p>
                      <p className='text-sm text-surface-400'>Add your first payment method</p>
                    </div>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default PaymentMethodsPage
